if (!customElements.get('announcement-bar-tosot')) {
  // 检查是否只有一个block, 解决只有一个block时闪烁问题
  const blockNumber = document.querySelector(".announcement-bar-tosot .swiper-wrapper")?.children.length;
  let isLoop = true;
  if(blockNumber === 1){
    isLoop = false;
  }
  /**
   * HeaderMenu
   */
  class AnnouncementBar extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{autoplay_time: Number}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings"));
      this.mySwiper = new Swiper(`#${this.id} .swiper`, {
        loop: isLoop,
        autoplay: this.sectionSettings.autoplay_time == 0 ? false : {
          delay: this.sectionSettings.autoplay_time * 1000 ?? 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        direction: 'vertical',
      });
      const popup = this.querySelector(".announcement_popup__outer");
      this.addEventListener("click", (event) => {
        if (event.target?.matches(".announcement_see_more")) {
          popup.style.display = "block";
        }
        if (event.target?.matches(".announcement_popup__esc")) {
          popup.style.display = "none";
        }
      });
    }

    connectedCallback() { }
  }

  customElements.define('announcement-bar-tosot', AnnouncementBar);
}